<footer class="footer">
  <ng-container
    [ngTemplateOutlet]="buttonLink() ? linkButton : nonLinkButton"
  />
</footer>

<ng-template #linkButton>
  <a
    btn
    [routerLink]="buttonLink()"
    [kind]="'SECONDARY'"
    [text]="buttonLabel()"
    (clicked)="buttonClick.emit()"
  >
  </a>
</ng-template>

<ng-template #nonLinkButton>
  <button
    btn
    [kind]="'SECONDARY'"
    [text]="buttonLabel()"
    (clicked)="buttonClick.emit()"
  ></button>
</ng-template>
